import { Component, OnInit } from '@angular/core';

import { ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { HelperService } from "../../services/helper/helper.service";
import { UserService } from "../../services/user/user.service";

import { MatSnackBar } from '@angular/material';
import { ToastComponent } from '../toast/toast.component';

import { LocalStorage } from '@ngx-pwa/local-storage';
import { Router } from "@angular/router"

@Component({
    selector: 'app-init',
    templateUrl: './init.component.html',
    styleUrls: ['./init.component.scss']
})
export class InitComponent implements OnInit {

    public loading = false;


    constructor(
        private route: ActivatedRoute,
        private location: Location,
        private helperService: HelperService,
        private userService: UserService,
        private snackBar: MatSnackBar,
        protected localStorage: LocalStorage,
        private router: Router
    ) { }

    ngOnInit() {
        this.getUserConfig();
    }

    getUserConfig(): void {
        this.loading = true;
        const jwt = this.route.snapshot.paramMap.get('jwt');

        this.userService.init(jwt).subscribe((res) => {
            if (res.success === true) {
                this.loading = false;
                // this.snackBar.openFromComponent(ToastComponent, {
                //     data: res.msg
                // });
                this.localStorage.setItem("payload", jwt).subscribe(() => {
                    var user = res.user;
                    user.integration_date = res.integration_date;
                    this.localStorage.setItem("user", res.user).subscribe(() => {
                        this.router.navigate(['/dash']);
                    })
                })
            } else {
                this.snackBar.openFromComponent(ToastComponent, {
                    data: res.msg
                });
                this.router.navigate(['/notfound']);
            }
        },(res)=>{
            this.localStorage.removeItem("user").subscribe(()=>{
                this.localStorage.removeItem("payload").subscribe(()=>{
                    this.loading = false;
                    this.snackBar.openFromComponent(ToastComponent, {
                        data: res.error.msg
                    });
                    this.router.navigate(['/notfound']);
                })
            })
        })

    }


}
